/**
 * @ngdoc directive
 * @name multi-account-login-form
 *
 * @description
 * A login form that handle multiple accounts for a single email
 */

module.directive('multiAccountLoginForm', function() {
    'use strict';

    return {
        restrict: 'E',
        replace: true,
        scope: {
            onLoginSuccess: '&',
            onError: '&',
            onFinally: '&',
            onSubmit: '&',
            onForgot: '&'
        },
        controller: ['$scope', '$q', 'drupal', function ($scope, $q, drupal) {
            resetForm();

            function callIfDefined(name, args) {
                if ($scope[name]) {
                    $scope[name].apply(null, args || []);
                }
            }

            function login() {
                return drupal.authenticate($scope.credentials).then(function() {
                    callIfDefined('onLoginSuccess')
                });
            }

            function updateAccountsList() {
                if ($scope.email === 'admin') {
                    $scope.credentials.name = $scope.email;
                    $scope.showAccountSelect = false;
                    $scope.showPasswordField = true;
                    return $q.when();
                }

                $scope.credentials.name = null;

                return drupal.getAccountsByEmail($scope.email).then(function(data) {
                    $scope.accounts = data;

                    switch ($scope.accounts.length) {
                        case 0:
                           throw new Error('Not accound found for this email');
                        case 1:
                            $scope.showAccountSelect = false;
                            $scope.showPasswordField = true;
                            $scope.credentials.name = data[0].name;
                            break;
                        default:
                            $scope.showPasswordField = false;
                            $scope.showAccountSelect = true;
                            break;
                    }
                });
            }

            function resetForm() {
                $scope.credentials = {
                    name: '',
                    pass: '',
                };

                $scope.email = null;
                $scope.accounts = [];
                $scope.hasError = false;
                $scope.showPasswordField = false;
                $scope.showAccountSelect = false;

                $scope.loading = false;

                if ($scope.loginForm) {
                    $scope.loginForm.$setPristine();
                    $scope.loginForm.$setUntouched();
                }
            }

            $scope.onAccountChange = function(account) {
                $scope.credentials.name = account.name;
                $scope.showPasswordField = Boolean(account);
            }

            $scope.previous = resetForm;

            $scope.submit = function(isValid) {
                if (!isValid) {
                    return;
                }

                var action = Boolean($scope.credentials.name) ? login : updateAccountsList;
                $scope.loading = true;
                callIfDefined('onSubmit');

                action().catch(function(err) {
                    $scope.hasError = true;
                    callIfDefined('onError', [err]);
                }).finally(function() {
                    $scope.loading = false;
                    callIfDefined('onFinally');
                });
            }
        }],
        templateUrl: 'src/components/multi-account-login-form/multi-account-login-form.html'
    };
});
